import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UserAccessService {
  private roles: any[] = [];

  setRoles(roles: any[]) {
    this.roles = roles || [];
  }

  clear() {
    this.roles = [];
  }

  isAllowed(sectionName: string): boolean {
    return this.roles.some(role =>
      role.permissionSections?.some(
        (s: any) => s.sectionName === sectionName && s.enabled === true
      )
    );
  }
}